import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import styles from './PageMainContentOverlay.module.scss';

const sectionId = 'PageMainContentOverlay';

interface PageMainContentOverlayProps {
  isOpen: boolean;
}

const PageMainContentOverlay: FC<PropsWithChildren<PageMainContentOverlayProps>> = ({ isOpen, children }) => (
  <div
    role="presentation"
    data-testid={sectionId}
    className={classNames(styles.root, {
      [styles.open]: isOpen,
    })}
  >
    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
    <div
      className={styles.overlay}
      onClick={(evt) => evt.stopPropagation()}
    >
      {children}
      <div className={styles.shadow} />
    </div>
  </div>
);

export { PageMainContentOverlay };
